import {h, Fragment} from "preact"
import { useActions, useAppState } from "@nosto/preact";
import { useEffect, useRef, useState } from "preact/hooks";
import { defaultConfig, sortOptions } from "../config";
import { render } from "preact";

const CustomDropdown = ({ sortOptions, handleSortChange, activeSort }) => {
  const [openDropdown, setOpenDropdown] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState(activeSort)
  const dropdownRef = useRef();

  useEffect(() => { setSelectedFilter(activeSort) }, [activeSort])

  useEffect(() => {
    if (!openDropdown) return
    const handleClickOutside = (e) => dropdownRef.current && !dropdownRef.current.contains(e.target) && setOpenDropdown(false);

    document.addEventListener("click", handleClickOutside);

    return () => document.removeEventListener("click", handleClickOutside);
  }, [openDropdown]);

  return (
    <>
      <span class="m-auto md-hide bold-text whitespace-nowrap">Sort by</span>
      <div ref={dropdownRef} class="custom-dropdown z-30 relative bg-white text-sm hover:bg-gray-50 flex-1 rounded-md flex gap-2 items-center">
        <button class="dropdown-button" onClick={() => setOpenDropdown(!openDropdown)}>
          <span class="flex-1 truncate">{sortOptions.find((o) => o.id === selectedFilter)?.value.name || "Sort by"}</span>
          <svg width="10" height="6" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg" class={`duration-300 ${openDropdown ? "rotate-180" : ""}`}>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0.292893 0.792893C0.683416 0.402369 1.31658 0.402369 1.7071 0.792893L4.99999 4.08579L8.29288 0.792893C8.6834 0.402369 9.31657 0.402369 9.70709 0.792893C10.0976 1.18342 10.0976 1.81658 9.70709 2.20711L5.7071 6.20711C5.31657 6.59763 4.68341 6.59763 4.29289 6.20711L0.292893 2.20711C-0.0976309 1.81658 -0.0976309 1.18342 0.292893 0.792893Z"
              fill="#707073"
            />
          </svg>
        </button>
        {openDropdown && (
          <div class="dropdown-content border border-gray-300">
            {sortOptions.map((sortOption) => (
              <div
                class="px-4 py-2 bg-white hover:bg-gray-50 block text-gray-700 cursor-pointer"
                onClick={() => {
                  setSelectedFilter(sortOption.id)
                  handleSortChange({ target: { value: sortOption.id } });
                  setOpenDropdown(false);
                }}
              >
                {sortOption.value.name}
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default ({ onlyForm, shouldShowNewSearch, sortByEl }) => {
  const { query } = useAppState();
  const { updateSearch } = useActions();
  const activeSort =
    sortOptions.find((option) => option.value.sort.every((v1) => query.products?.sort?.find((v2) => v1.field === v2.field && v1.order === v2.order)))?.id ?? defaultConfig.sort.id;
  const collectionUrl = window?.location?.pathname || "";

  const handleSortChange = (e) => {
    updateSearch({
      products: {
        sort: sortOptions.find((v) => v.id === e?.target?.value)?.value?.sort,
      },
    });
  };

  const Form = () => (
    <form id="sort_by_form" class="flex-1" method="GET" target="_top" action={collectionUrl}>
      <select name="sort_by" class={window.cj.nosto.newSearchFeatureEnabled ? "featured-dropdown w-full" : "sidebar-select"} value={activeSort} onChange={handleSortChange}>
        {sortOptions.map((sortOption) => (
          <option value={sortOption.id}>{sortOption.value.name}</option>
        ))}
      </select>
    </form>
  );

  if (sortByEl) // render inside 'collection-title-header' section
    return render(<div class="flex gap-2"><CustomDropdown sortOptions={sortOptions} handleSortChange={handleSortChange} activeSort={activeSort} /></div>, sortByEl)

  if (onlyForm) {
    return shouldShowNewSearch ? <CustomDropdown sortOptions={sortOptions} handleSortChange={handleSortChange} activeSort={activeSort} /> : <Form />;
  }

  return (
    <div class="plp-sort-desktop">
      <div class="plp-sort-desktop__wrapper">
        <div class="sec-sidebar--label">Sort by</div>
        {shouldShowNewSearch ? <CustomDropdown sortOptions={sortOptions} handleSortChange={handleSortChange} activeSort={activeSort} /> : <Form />}
      </div>
    </div>
  );
};
